<template>
    <div class="news-sidebar">
        <div class="filter-box sidebar-margin white-bg-box">
            <q-btn style="background: #25408f; color: white" label="Zoeken" @click="searchDashboard" dense>
                <i class="las la-search la-fw"></i>
            </q-btn>
        </div>

        <div class="filter-box sidebar-margin orgs-box">
            <span class="org-heading">Ontvanger</span>
            <div class="row start orgs-select">
                <q-select dense outlined bg-color="white" v-model="selectedCustomers" multiple
                    :options="filterCustomersTags" option-value="label" class="budget-input" option-label="label"
                    placeholder="Zoek een ontvanger" use-input input-debounce="800" behavior="menu" use-chips
                    @filter="filterCustomerFn" clearable>
                    <template v-slot:no-option>
                        <q-item>
                            <q-item-section class="text-grey">
                                No results
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div>
        </div>
        <div class="filter-box sidebar-margin orgs-box">
            <span class="org-heading">Verstrekker</span>
            <div class="row start orgs-select">
                <q-select dense outlined bg-color="white" v-model="selectedOrganisations" multiple
                    :options="filterOrganisationsTags" option-value="label" class="budget-input" option-label="label"
                    placeholder="Zoek een verstrekker" use-input input-debounce="0" behavior="menu" use-chips
                    @filter="filterOrganisationsFn" clearable>
                    <template v-slot:no-option>
                        <q-item>
                            <q-item-section class="text-grey">
                                No results
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div>
        </div>

        <div class="filter-box sidebar-margin orgs-box">
            <span class="org-heading">Regeling</span>
            <div class="row start orgs-select">
                <q-select dense outlined bg-color="white" v-model="selectedSubjects" multiple
                    :options="filterSubjectsTags" option-value="label" class="budget-input" option-label="label"
                    placeholder="Zoek een regeling" use-input input-debounce="0" behavior="menu" use-chips
                    @filter="filterSubjectsFn" clearable>
                    <template v-slot:no-option>
                        <q-item>
                            <q-item-section class="text-grey">
                                No results
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div>
        </div>

        <div class="filter-box sidebar-margin orgs-box">
            <span class="org-heading">Selecteer scope</span>
            <div class="row start orgs-select">
                <q-select dense outlined bg-color="white" v-model="selectedScopes" multiple :options="scopesOptions"
                    option-value="id" class="budget-input" option-label="name" placeholder="Select scope"
                    input-debounce="0" behavior="menu" use-chips clearable label="Scope">
                    <template v-slot:no-option>
                        <q-item>
                            <q-item-section class="text-grey">
                                No results
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div>
        </div>
        <div class="filter-box sidebar-margin white-bg-box">
            <div class="row justify-between">
                <span class="org-heading">Publicatiedatum</span>
                <i class="las la-2x la-times-circle clear-icon" @click="resetDate()">
                    <q-tooltip> Filter leegmaken </q-tooltip>
                </i>
            </div>
            <q-input class="budget-input" bg-color="white" v-model="daysRangeModel" outlined dense
                @click="$refs.qDateProxy.show()" :update="updateRange()">
                <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer datepicker-icon">
                        <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                            <q-date range v-model="days" mask="DD-MM-YYYY">
                                <div class="row items-center justify-end">
                                    <q-btn v-close-popup label="Sluiten" color="primary" flat />
                                </div>
                            </q-date>
                        </q-popup-proxy>
                    </q-icon>
                </template>
            </q-input>
        </div>

        <div class="filter-box sidebar-margin white-bg-box">
            <q-btn style="background: #25408f; color: white" label="Zoeken" @click="searchDashboard" dense>
                <i class="las la-search la-fw"></i>
            </q-btn>
        </div>
    </div>
</template>
<script>
import { ref, computed, watch, onMounted } from 'vue';
import store from '../../store/index';
import RecordsUtil from '../../utils/records'
import FiltersService from '../../services/filters.service';

export default {
    name: "RecordsSideBarSearch",
    components: {

    },
    setup() {
        const daysRangeModel = ref(null);

        onMounted(() => {
            var fileId = store.state.fileRecords.fileId;
            FiltersService.getDefaultFileFilters(fileId);
        });

        const dateFrom = computed({
            get: () => store.state.fileRecords.daysRange.from,
        });

        const dateTo = computed({
            get: () => store.state.fileRecords.daysRange.to,
        });

        const days = computed({
            get: () => store.state.fileRecords.daysRange,
            set: (val) => {
                store.commit('fileRecords/updateDaysRange', val);
            },
        });

        const updateRange = () => {
            daysRangeModel.value = [dateFrom.value, dateTo.value].join(' - ');
        };

        const resetDate = () => {
            store.commit('fileRecords/updateDaysRange', { from: '', to: '' });
        };

        //Customers
        const customerOptions = computed({
            get: () => store.state.fomoStatisticsSearch.customersOptions,
        });

        const customerOptionsOriginal = computed({
            get: () => store.state.fomoStatisticsSearch.customersOptions,
        });
        const mainCustomerOptions = computed({
            get: () => store.state.fomoStatisticsSearch.customersMainOptions,
        });
        const filterCustomersTags = ref(customerOptions.value);
        const selectedCustomers = computed({
            get: () => store.state.fomoStatisticsSearch.customersSelectArray,
            set: async (value) => {
                store.commit('fomoStatisticsSearch/updateSelectedCustomers', value);
            },
        });

        //Main customer
        const filterMainCustomerTags = ref(mainCustomerOptions.value);

        const selectedMainCustomer = computed({
            get: () => store.state.fomoStatisticsSearch.selectedMainCustomer,
            set: (val) => {
                store.commit('fomoStatisticsSearch/updateSelectedMainCustomer', val);
            },
        });
        watch(selectedCustomers, () => {
            if (selectedCustomers.value == null) {
                store.commit('fomoStatisticsSearch/updateSelectedCustomers', null);
            }
        });

        //Organisations
        const organisationsOptions = computed({
            get: () => store.state.fomoStatisticsSearch.organisationsOptions,
        });
        const filterOrganisationsTags = ref(organisationsOptions.value);
        const selectedOrganisations = computed({
            get: () => store.state.fomoStatisticsSearch.organisationsSelectArray,
            set: async (value) => {
                store.commit('fomoStatisticsSearch/updateSelectedOrganisations', value);
            },
        });
        watch(selectedOrganisations, () => {
            if (selectedOrganisations.value == null) {
                store.commit('fomoStatisticsSearch/updateSelectedOrganisations', null);
            }
        });
        //Subjects
        const subjectsOptions = computed({
            get: () => store.state.fomoStatisticsSearch.subjectsOptions,
        });
        const filterSubjectsTags = ref(subjectsOptions.value);
        const selectedSubjects = computed({
            get: () => store.state.fomoStatisticsSearch.subjectsSelectArray,
            set: async (value) => {
                store.commit('fomoStatisticsSearch/updateSelectedSubjects', value);
            },
        });
        watch(selectedSubjects, () => {
            if (selectedSubjects.value == null) {
                store.commit('fomoStatisticsSearch/updateSelectedSubjects', null);
            }
        });

        //Scopes
        const selectedScopes = computed({
            get: () => store.state.fomoStatisticsSearch.selectedScopes,
            set: (val) => store.commit('fomoStatisticsSearch/setSelectedScopes', val),
        });

        const scopesOptions = computed({
            get: () => store.state.fomoStatisticsSearch.scopesOptions,
        });
        watch(selectedScopes, () => {
            if (selectedScopes.value == null) {
                store.commit('fomoStatisticsSearch/setSelectedScopes', null);
            }
        });

        const searchDashboard = async () => {
            RecordsUtil.searchRecords();
        }

        return {
            daysRangeModel,
            updateRange,
            days,
            resetDate,
            dateFrom,
            dateTo,
            filterSubjectsTags,
            filterOrganisationsTags,
            selectedMainCustomer,
            filterMainCustomerTags,
            filterCustomersTags,
            customerOptionsOriginal,
            searchDashboard,
            selectedOrganisations,
            selectedSubjects,
            selectedCustomers,
            scopesOptions,
            selectedScopes,
            filterCustomerFn(val, update) {
                update(async () => {
                    filterCustomersTags.value = [];
                    if (val === '') {
                        filterCustomersTags.value = [];
                    } else {
                        await FiltersService.getCustomersFilter(val);

                        if (customerOptions.value != null)
                            filterCustomersTags.value = customerOptions.value;
                        else
                            filterCustomersTags.value = [];
                    }
                });
            },
            filterOrganisationsFn(val, update) {
                update(() => {
                    if (val === '') {
                        filterOrganisationsTags.value = organisationsOptions.value;
                    } else {
                        const needle = val.toLowerCase();

                        filterOrganisationsTags.value = organisationsOptions.value.filter(
                            (v) => v.label.toLowerCase().indexOf(needle) > -1
                        );
                    }
                });
            },
            filterSubjectsFn(val, update) {
                update(() => {
                    if (val === '') {
                        filterSubjectsTags.value = subjectsOptions.value;
                    } else {
                        const needle = val.toLowerCase();

                        filterSubjectsTags.value = subjectsOptions.value.filter(
                            (v) => v.label.toLowerCase().indexOf(needle) > -1
                        );
                    }
                });
            }
        }
    }
}
</script>
